import Vue from 'vue';

Vue.component('item-box-chart', () =>
    import(/* webpackChunkName: 'item' */ './boxChart.vue'),
);
Vue.component('vuetable-tag-sales', () =>
    import(/* webpackChunkName: 'item' */ './vuetable_tag_sales.vue'),
);
Vue.component('vuetable-category-sales', () =>
    import(/* webpackChunkName: 'item' */ './vuetable-category-sales.vue'),
);
Vue.component('vuetable-staff-sales', () =>
    import(/* webpackChunkName: 'item' */ './vuetable-staff-sales.vue'),
);
Vue.component('variant-sales-report', () =>
    import(/* webpackChunkName: 'item' */ './variant-sales-report.vue'),
);
